<template lang="pug">
    app-dialog(v-model="$_show" :header="headerText" :confirm-text="confirmText" :confirm-disabled="isNotReady" @confirm="sign" width="756")
      v-form(ref="signForm" v-model="valid")
         app-select(v-if="certList.length > 0" v-model="cert" :items="certList" label="Выберите сертификат" item-text="text" :rules="[rules.required]")
         app-button(v-else) Средства криптографии не установлены

              
            
</template>

<script>
import { AppDialogToggable } from '@/components'
import {$_sign} from './sign'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [AppDialogToggable, $_sign, $_validate_rules],
  props: {
    appId: null,
  },
  data () {
    return {
      valid: false,
      isCarmaInit: false,
      cert: null,
      certList: []
    }
  },
  methods: {
    fail(text) {
      this.$emit('sendfail', text)
    },
    ok(text) {
      this.$emit('ok', text)
    },
    carmaInit () {
      this.isCarmaInit=true
    },
    sign() {
      if (this.$refs.signForm.validate() && this.cert!=null) {
          this.$sign_setComponent("specialist")
          this.$sign_setOk(this.ok)
          this.$sign_setFail(this.fail)

          this.$sign_signFileFunction(this.appId, this.cert.value)
      }
    }
  },
  computed: {
    isNotReady () {
      return !this.valid
    },
    confirmText() {
      let txt= "Подписать"
      return (this.certList.length > 0) ? txt : ""
    },
    headerText() {
      return "Подписать постановление"
    }
  },
  watch: {
    isCarmaInit (value) {
      if (value) this.certList = this.$sign_loadFunction()
    },
  },
  created() {
    this.$sign_carmaInit(this.carmaInit)
  }
}
</script>

<style lang="scss" scoped>

.sud-dialog-card__footer {
  text-align: right;
  padding-top: 16px;
}

</style>

